import { render, staticRenderFns } from "./LikeCreateView.vue?vue&type=template&id=034f2d21"
import script from "./LikeCreateView.vue?vue&type=script&lang=js"
export * from "./LikeCreateView.vue?vue&type=script&lang=js"
import style0 from "./LikeCreateView.vue?vue&type=style&index=0&id=034f2d21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports